

export default function LinkSvg() {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0171 15.4763C19.3693 14.6103 18.5427 13.8936 17.5936 13.3751C16.6444 12.8565 15.5949 12.5481 14.5161 12.4709C13.4373 12.3936 12.3545 12.5493 11.3411 12.9273C10.3278 13.3053 9.40756 13.8968 8.64292 14.6617L4.11739 19.1873C2.74345 20.6098 1.9832 22.5151 2.00039 24.4927C2.01757 26.4703 2.81082 28.3621 4.20927 29.7606C5.60772 31.159 7.49949 31.9523 9.47712 31.9694C11.4548 31.9866 13.36 31.2264 14.7826 29.8524L17.3772 27.2729"
        stroke="#031F42"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.983 18.4933C14.6308 19.3594 15.4574 20.076 16.4065 20.5946C17.3557 21.1132 18.4052 21.4215 19.484 21.4988C20.5628 21.5761 21.6456 21.4204 22.659 21.0424C23.6723 20.6644 24.5925 20.0729 25.3572 19.3079L29.8827 14.7824C31.2567 13.3599 32.0169 11.4546 31.9997 9.47696C31.9825 7.49933 31.1893 5.60756 29.7908 4.20911C28.3924 2.81066 26.5006 2.01742 24.523 2.00023C22.5454 1.98305 20.6401 2.74329 19.2175 4.11723L16.638 6.69679"
        stroke="#031F42"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
